import React, { useState } from 'react'
import { Button, Col, Container, Form, Row } from 'react-bootstrap';

const paymentList = [
    {
        code: 1,
        name: "عماد طالبی",
        date: "1402/11/04",
        status: "عوارض نوسازی",
        ghabzId: "12345677899",
        pardakhtId: "12347",
        amount: "19000000",
        address: "خیابان هراز،آفتاب 33، کوچه بهار، پلاک 60"
    },
    {
        code: 2,
        name: "مهرداد اکبری",
        date: "1402/01/01",
        status: "عوارض صدور پروانه",
        ghabzId: "12345677890",
        pardakhtId: "12345",
        amount: "17000000",
        address: "خیابان هراز،آفتاب 18، کوچه یاس، پلاک 66"
    }
]

function TollPayment() {
    const [paymentStatus, setPaymentStatus] = useState("")

    const paymentHandler = (id) => {
    }

    return (
        <div>
            <Container>
                <Row className="justify-content-center pt-5 payment-list">
                    <Col xs={12} md={9} className='mb-4'>
                        <Form.Group className='col-xs-12 col-md-4'>
                            <Form.Label>
                                <div className="d-flex rgc-title my-2">
                                    <div className="rgc-title-point"></div>
                                    <h4>وضعیت پرداخت</h4>
                                </div>
                            </Form.Label>
                            <Form.Select
                                className="rgc-select"
                                value={paymentStatus}
                                onChange={(e) => setPaymentStatus(e.target.value)
                                }
                            >
                                <option value="0">لطفا انتخاب کنید</option>
                                <option value="1">پرداخت شده</option>
                                <option value="2">در انتظار پرداخت</option>

                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                لطفا گزینه مورد نظر را وارد نمایید
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>

                    {paymentList.map((data, index) => {
                        return (
                            <Col xs={11} lg={9} className="rgc-request my-2 position-relative overflow-hidden" for="requestCode">
                                {/* <Col md={1} className='d-none d-md-block'> */}
                                <div className='d-none d-md-block'>
                                    <div className='d-flex flex-column gap-4 position-absolute'>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                    </div>
                                </div>
                                {/* </Col> */}
                                <Row key={index} className="rgc-content-request px-0 px-md-5 py-3 g-0">
                                    <Col xs={4} md={2}>
                                        تاریخ:
                                    </Col>
                                    <Col xs={8} md={2}>
                                        {data.date}
                                    </Col>

                                    <Col xs={4} md={2}>
                                        شناسه قبض:
                                    </Col>
                                    <Col xs={8} md={2}>
                                        {data.ghabzId}
                                    </Col>

                                    <Col xs={4} md={2}>
                                        شناسه پرداخت:
                                    </Col>
                                    <Col xs={8} md={2}>
                                        {data.pardakhtId}
                                    </Col>
                                    <hr />

                                    <Col xs={12} md={6}>
                                        <div className='d-flex flex-column'>
                                            <div className='d-flex gap-2'>
                                                <span>نام و نام خانوادگی:</span>
                                                <span>{data.name}</span>
                                            </div>
                                            <div className='d-flex gap-2'>
                                                <span> آدرس:</span>
                                                <span> {data.address}</span>
                                            </div>
                                            <div className='d-flex gap-2'>
                                                <span>کد:</span>
                                                <span>{data.code}</span>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col xs={12} md={6}>
                                        <div className='d-flex flex-column shadow rounded-2 p-2 bg-light'>
                                            <div className='d-flex justify-content-around'>
                                                <span> نوع عوارض:</span>
                                                <span>{data.status}</span>
                                            </div>
                                            <div className='d-flex justify-content-around'>
                                                <span>مبلغ:</span>
                                                <span>{Intl.NumberFormat('en-Us').format(data.amount)}&nbsp;&nbsp;ریال</span>
                                            </div>
                                            <div className='d-flex justify-content-center'>
                                                <Button className="float-start rgc-follow-btn m-2 text-white"
                                                    onClick={() => paymentHandler(data.code)}
                                                > پرداخت </Button>
                                            </div>
                                        </div>

                                    </Col>
                                </Row>
                            </Col>
                        );
                    })}
                </Row>
            </Container>
        </div>
    )
}

export default TollPayment
